import getHoursInRange from '@/logic/helpers/dates/getHoursInRange';
import getFullHour from '@/logic/helpers/dates/getFullHour';
import setFullDate from '@/logic/helpers/dates/setFullDate';

export interface takenSlot {
  assessment_dates: assessmentDate[];
  assessment_id: string;
  candidate:
    | {
        first_name: string;
        id: string;
        profile_image: string;
        surname: string;
      }
    | string;
}

interface assessmentDate {
  date_end: string;
  date_start: string;
  status: string;
}

export interface bookedSlot {
  bookedCandidate: takenSlot['candidate'];
  meetingStatus: string;
  bookedHour?: string;
  bookedDate?: string;
}

export const helpToApplyTakenSlots = (
  takenSlots: takenSlot[],
  targetFormat: string,
): bookedSlot[] => {
  const bookedSlots: bookedSlot[] = [];

  takenSlots?.forEach((takenSlot) => {
    takenSlot.assessment_dates.forEach((assessmentDate) => {
      const startHour: string = getFullHour(assessmentDate.date_start);
      const endHour: string = getFullHour(assessmentDate.date_end);
      const hoursInRange: string[] = getHoursInRange(startHour, endHour);

      createBookedSlot({ hoursInRange, takenSlot, targetFormat, assessmentDate, bookedSlots });
    });
  });

  return bookedSlots;
};

interface createBookedSlotArgs {
  hoursInRange: string[];
  takenSlot: takenSlot;
  targetFormat: string;
  assessmentDate: assessmentDate;
  bookedSlots: bookedSlot[];
}

const createBookedSlot = (args: createBookedSlotArgs): void => {
  args.hoursInRange?.forEach((hour) => {
    const bookedSlot: bookedSlot = {
      bookedCandidate: args.takenSlot.candidate,
      meetingStatus: args.assessmentDate.status,
    };

    if (args.targetFormat === 'hour') bookedSlot.bookedHour = hour;
    if (args.targetFormat === 'date')
      bookedSlot.bookedDate = setFullDate(args.assessmentDate.date_start, hour);

    args.bookedSlots.push(bookedSlot);
  });
};
